import React from "react";
import { Alert } from "@material-ui/lab";
import LogsItem from "./LogsItem";
import { useTranslation } from "react-i18next";
import FragmentSpinner from "../../../elements/spinner/FragmentSpinner";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import { StyledLoadingWrapper } from "../../../elements/spinner/styledSpinner";

const LogsList = ({ loading, logs }) => {
  const { t } = useTranslation("logsPage");

  if (loading.main && logs.length === 0) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (logs.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <>
      <StyledScrollTable className="logs-table_scroll">
        <StyledTable
          width="1470"
          size="14"
          className="logs-table"
        >
          <StyledTableHead
            scroll="auto"
            col="6"
            className="logs-table__head-system"
          >
            <div>
              {t("table.role")}
            </div>
            <div>
              E-mail
            </div>
            <div>
              {t("table.levelName")}
            </div>
            <div>
              {t("table.event")}
            </div>
            <div>
              {t("table.date")}
            </div>
            <div>
              IP
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {logs.map((value, key) => (
              <LogsItem key={key} value={value} />
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
      {loading.fragment &&
        <StyledLoadingWrapper>
          <FragmentSpinner position="center" />
        </StyledLoadingWrapper>
      }
    </>
  );
};

export default LogsList;